import './App.css';
import { Portfolio } from './components/Portfolio';

// import { VideoModal } from './components/VideoModal';

function App() {
  return (
    <div className="App">
      <Portfolio />
      {/* <VideoModal /> */}
    </div>
  );
}

export default App;
